import api from '~/api/'

const getDefaultState = () => ({
    showPayment: false,
    memberInfo: null,
    memberinfoTab: 0,
    memberPhoneNo: null,
    sessionInfo: null,
    sessionLoaded: false,
    sessionCheckedAt: 0,
})

export const state = () => getDefaultState()

export const mutations = {
    SET_SHOW_PAYMENT(state, show) {
        state.showPayment = show
    },

    SET_MEMBER_INFO(state, data) {
        state.memberInfo = data ? { ...data } : null
    },
    RESET_MEMBER_INFO(state) {
        state.memberInfo = null
    },

    SET_CLEAR_MEMBERINFO(state) {
        state.memberInfo = null
    },

    SET_RESET_ALL_STORE_ITEM(state) {
        Object.assign(state, getDefaultState())
    },
    SET_DEPOSIT_PAGE(state) {
        state.memberinfoTab = 2
    },

    SET_MEMBER_PHONE_NUM(state, memberPhoneNo) {
        state.memberPhoneNo = memberPhoneNo
    },

    SET_SESSION_INFO(state, data) {
        state.sessionInfo = data ? { ...data } : null
        state.sessionLoaded = true
        state.sessionCheckedAt = Date.now()
    },
    CLEAR_SESSION_INFO(state) {
        state.sessionInfo = null
        state.sessionLoaded = true
        state.sessionCheckedAt = Date.now()
    },
}

export const actions = {
    async GET_MEMBER_INFO({ commit }, params) {
        try {
            const res = await api.getMemberInfo(params)

            if (res && res.success) {
                commit('SET_MEMBER_INFO', res.data)
                return res.data
            }

            console.log('main_page member -> ', res?.success)
            commit('SET_MEMBER_INFO', null)
            return null
        } catch (err) {
            console.log('main_page member -> ', err)
            commit('SET_MEMBER_INFO', null)
            return null
        }
    },

    async FETCH_MEMBER_INFO({ dispatch }, params) {
        return await dispatch('GET_MEMBER_INFO', params)
    },

    SET_MEMBER_INFO({ commit }, data) {
        commit('SET_MEMBER_INFO', data)
    },

    CLEAR_MEMBERINFO({ commit }) {
        commit('SET_CLEAR_MEMBERINFO')
    },

    CLEAR_MEMBER_INFO({ commit }) {
        commit('RESET_MEMBER_INFO')
    },

    RESET_ALL_STORE_ITEM({ commit }) {
        commit('SET_RESET_ALL_STORE_ITEM')
    },

    SET_SESSION_INFO({ commit }, data) {
        commit('SET_SESSION_INFO', data)
    },

    CLEAR_SESSION_INFO({ commit }) {
        commit('CLEAR_SESSION_INFO')
    },

    async LOGOUT({ commit, dispatch }) {
        try {
            const res = await api.logout({})

            commit('SET_RESET_ALL_STORE_ITEM')

            dispatch('search/RESET_ALL_STORE_ITEM', null, { root: true })
            dispatch('board/RESET_ALL_STORE_ITEM', null, { root: true })
            dispatch('research/RESET_ALL_STORE_ITEM', null, { root: true })
            dispatch('theme/RESET_ALL_STORE_ITEM', null, { root: true })

            return !!(res && res.success)
        } catch (e) {
            commit('SET_RESET_ALL_STORE_ITEM')
            return false
        }
    },

    async UPDATE_PASSWORD(context, params) {
        return await api.updatePassword(params)
    },

    async UPDATE_NICKNAME(context, params) {
        try {
            return await api.updateNickname(params)
        } catch (e) {
            console.error('error=', e)
            return null
        }
    },

    async DELETE_ACCOUNT(context, params) {
        try {
            return await api.deleteAccount(params)
        } catch (e) {
            console.error('DELETE_ACCOUNT error=', e)
            return null
        }
    },
}

export const getters = {}

export default {
    state,
    mutations,
    actions,
    getters,
}